import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { defaultNS, resources } from "../shared";

void i18n.use(initReactI18next).init({
  lng: "en",
  debug: false,
  ns: ["main", "common"], // 'sandbox' will only be loaded when needed
  defaultNS,
  resources,
  interpolation: {
    escapeValue: false,
  },
});

export { i18n };
export type { I18nKeyType } from "../shared";
